// dnd-kit ids must be unique per DndContext, and every folder already
// registers its bare id via the sidebar tree node — so table rows register
// under a namespaced id and the page strips it back off in onDragEnd.
const TABLE_ROW_DND_PREFIX = 'table-row:';

export function tableRowDndId(id: string): string {
  return `${TABLE_ROW_DND_PREFIX}${id}`;
}

export function stripTableRowDndId(id: string): string {
  return id.startsWith(TABLE_ROW_DND_PREFIX) ? id.slice(TABLE_ROW_DND_PREFIX.length) : id;
}
